const Login = {
  welcome_back: "Welcome Back",
  remember_me: "Remember me",
  forgot_username_or_password: "Forgot User Name or Password",
  i_dont_have_an_account: "I don't have account",
};
export default Login;
